'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = exports.LOG_CLICK_BOOK_NOW = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics;

exports.default = reducer;
exports.load = load;
exports.loadAvailability = loadAvailability;
exports.loadPeerReview = loadPeerReview;
exports.loadPeerTrips = loadPeerTrips;
exports.updatePeerTrips = updatePeerTrips;
exports.openChat = openChat;
exports.openBook = openBook;
exports.openExternal = openExternal;
exports.openShare = openShare;
exports.openPeerReview = openPeerReview;
exports.submitPeerReview = submitPeerReview;
exports.clearData = clearData;
exports.clickTrip = clickTrip;
exports.impressTrip = impressTrip;
exports.clickSimilarTrip = clickSimilarTrip;
exports.impressSimilarTrip = impressSimilarTrip;
exports.impressSuggestionTrip = impressSuggestionTrip;
exports.clickSuggestionTrip = clickSuggestionTrip;
exports.logClickBookNow = logClickBookNow;
exports.requestSuggestionTrip = requestSuggestionTrip;
exports.changeTab = changeTab;
exports.copyLink = copyLink;
exports.logCopyFirstBookingCode = logCopyFirstBookingCode;
exports.logCopySecondOffCode = logCopySecondOffCode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-frontend/trip/LOAD';
var LOAD_SUCCESS = 'redux-frontend/trip/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/trip/LOAD_FAIL';

var LOAD_PEER_TRIPS = 'redux-frontend/trip/LOAD_PEER_TRIPS';
var LOAD_PEER_TRIPS_SUCCESS = 'redux-frontend/trip/LOAD_PEER_TRIPS_SUCCESS';
var LOAD_PEER_TRIPS_FAIL = 'redux-frontend/trip/LOAD_PEER_TRIPS_FAIL';

var UPDATE_PEER_TRIPS = 'redux-frontend/trip/UPDATE_PEER_TRIPS';

var LOAD_AVAILABILITY = 'redux-frontend/trip/LOAD_AVAILABILITY';
var LOAD_AVAILABILITY_SUCCESS = 'redux-frontend/trip/LOAD_AVAILABILITY_SUCCESS';
var LOAD_AVAILABILITY_FAIL = 'redux-frontend/trip/LOAD_AVAILABILITY_FAIL';

var LOAD_PEER_REVIEW = 'redux-frontend/trip/LOAD_PEER_REVIEW';
var LOAD_PEER_REVIEW_SUCCESS = 'redux-frontend/trip/LOAD_PEER_REVIEW_SUCCESS';
var LOAD_PEER_REVIEW_FAIL = 'redux-frontend/trip/LOAD_PEER_REVIEW_FAIL';

var SUBMIT_PEER_REVIEW = 'redux-frontend/trip/SUBMIT_PEER_REVIEW';
var SUBMIT_PEER_REVIEW_SUCCESS = 'redux-frontend/trip/SUBMIT_PEER_REVIEW_SUCCESS';
var SUBMIT_PEER_REVIEW_FAIL = 'redux-frontend/trip/SUBMIT_PEER_REVIEW_FAIL';

var OPEN_EXTERNAL = 'redux-frontend/trip/OPEN_EXTERNAL';
var CLICK_TRIP = 'redux-frontend/trip/CLICK_TRIP';
var IMPRESS_TRIP = 'redux-frontend/trip/IMPRESS_TRIP';
var CLICK_SIMILAR_TRIP = 'redux-frontend/trip/CLICK_SIMILAR_TRIP';
var IMPRESS_SIMILAR_TRIP = 'redux-frontend/trip/IMPRESS_SIMILAR_TRIP';
var OPEN_CHAT = 'redux-frontend/trip/OPEN_CHAT';
var CLEAR_DATA = 'redux-frontend/trip/CLEAR_DATA';
var OPEN_BOOK = 'redux-frontend/trip/OPEN_BOOK';
var OPEN_SHARE = 'redux-frontend/trip/OPEN_SHARE';
var OPEN_PEER_REVIEW = 'redux-frontend/trip/OPEN_PEER_REVIEW';

var IMPRESS_SUGGESTION_TRIP = 'redux-frontend/trip/IMPRESS_SUGGESTION_TRIP';
var CLICK_SUGGESTION_TRIP = 'redux-frontend/trip/CLICK_SUGGESTION_TRIP';
var REQUEST_SUGGESTION_TRIP = 'redux-frontend/trip/REQUEST_SUGGESTION_TRIP';
var CHANGE_TAB = 'redux-frontend/trip/CHANGE_TAB';
var COPY_LINK_SUCCESS = 'redux-frontend/trip/COPY_LINK_SUCCESS';
var LOG_COPY_FIRSTBOOKING_CODE = 'redux-frontend/trip/LOG_COPY_FIRSTBOOKING_CODE';
var LOG_COPY_SECONDOFF_CODE = 'redux-frontend/trip/LOG_COPY_SECONDOFF_CODE';

var initialState = {
  loaded: false,
  openChat: false,
  openBook: false,
  openShare: false,
  isOpenPeerReview: false,
  data: {},
  mobileTab: 'overview',
  peerReviewData: {},
  isLoadingPeerReview: false,
  isSubmittingPeerReview: false,
  peerTrips: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CLEAR_DATA:
      return (0, _extends3.default)({}, state, {
        data: {}
      });
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: {},
        error: action.result
      });
    case LOAD_PEER_TRIPS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        peerTrips: action.result
      });
    case UPDATE_PEER_TRIPS:
      return (0, _extends3.default)({}, state, {
        peerTrips: action.peerTrips
      });
    case LOAD_AVAILABILITY:
      return (0, _extends3.default)({}, state, {
        loadingAvailability: true
      });
    case LOAD_AVAILABILITY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadingAvailability: false,
        loaded: true,
        availability: action.result,
        error: null
      });
    case LOAD_AVAILABILITY_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingAvailability: false,
        loaded: false,
        availability: null,
        error: action.result
      });
    case LOAD_PEER_REVIEW:
      return (0, _extends3.default)({}, state, {
        isLoadingPeerReview: true
      });
    case LOAD_PEER_REVIEW_SUCCESS:
      return (0, _extends3.default)({}, state, {
        isLoadingPeerReview: false,
        peerReviewData: action.result
      });
    case LOAD_PEER_REVIEW_FAIL:
      return (0, _extends3.default)({}, state, {
        isLoadingPeerReview: false
      });
    case SUBMIT_PEER_REVIEW:
      return (0, _extends3.default)({}, state, {
        isSubmittingPeerReview: true
      });
    case SUBMIT_PEER_REVIEW_SUCCESS:
      return (0, _extends3.default)({}, state, {
        // peerReviewData: action.result,
        isSubmittingPeerReview: false
      });
    case SUBMIT_PEER_REVIEW_FAIL:
      return (0, _extends3.default)({}, state, {
        isSubmittingPeerReview: false
      });
    case OPEN_CHAT:
      return (0, _extends3.default)({}, state, {
        openChat: action.active
      });
    case OPEN_BOOK:
      return (0, _extends3.default)({}, state, {
        openBook: action.active
      });
    case OPEN_SHARE:
      return (0, _extends3.default)({}, state, {
        openShare: action.active
      });
    case OPEN_PEER_REVIEW:
      return (0, _extends3.default)({}, state, {
        isOpenPeerReview: action.open
      });
    case CHANGE_TAB:
      return (0, _extends3.default)({}, state, {
        mobileTab: action.tab
      });
    case COPY_LINK_SUCCESS:
      return (0, _extends3.default)({}, state, {
        openShare: false
      });
    default:
      return state;
  }
}

var LOG_CLICK_BOOK_NOW = exports.LOG_CLICK_BOOK_NOW = 'redux-frontend/trip/LOG_CLICK_BOOK_NOW';

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, OPEN_CHAT, function (action) {
  return action.active ? { name: 'Open Message Modal', category: 'Booking' } : { name: 'Close Message Modal', category: 'Booking' };
}), (0, _defineProperty3.default)(_analytics, OPEN_EXTERNAL, function (action) {
  return { name: 'Open External', category: 'Trip', url: action.url };
}), (0, _defineProperty3.default)(_analytics, CLICK_TRIP, function (action) {
  return { name: 'Click Trip', category: 'Trip', tripId: action.id, providers: 'database', searchSessionId: action.searchSessionId, ranking_algorithm: action.rankingAlgorithm, index: action.index };
}), (0, _defineProperty3.default)(_analytics, LOG_CLICK_BOOK_NOW, function (action) {
  return { name: 'Click Book Now', category: 'Trip', tripId: action.id, providers: 'database', searchSessionId: action.searchSessionId, ranking_algorithm: action.rankingAlgorithm, index: action.index };
}), (0, _defineProperty3.default)(_analytics, IMPRESS_TRIP, function (action) {
  return { name: 'Impress Trip', category: 'Trip', tripId: action.id, providers: 'database', searchSessionId: action.searchSessionId, ranking_algorithm: action.rankingAlgorithm, index: action.index };
}), (0, _defineProperty3.default)(_analytics, CLICK_SIMILAR_TRIP, function (action) {
  return { name: 'Click Similar Trip', category: 'Similar Trip', tripId: action.id, type: action.typeSim, index: action.index, providers: 'database' };
}), (0, _defineProperty3.default)(_analytics, IMPRESS_SIMILAR_TRIP, function (action) {
  return { name: 'Impress Similar Trip', category: 'Similar Trip', tripId: action.id, type: action.typeSim, index: action.index, providers: 'database' };
}), (0, _defineProperty3.default)(_analytics, IMPRESS_SUGGESTION_TRIP, function (action) {
  return { name: 'Impress Suggestion Trips', category: 'Suggestion Trip', bookingId: action.bookingId, providers: 'database' };
}), (0, _defineProperty3.default)(_analytics, CLICK_SUGGESTION_TRIP, function (action) {
  return { name: 'Click Suggestion Trip', category: 'Suggestion Trip', bookingId: action.bookingId, tripId: action.id, providers: 'database' };
}), (0, _defineProperty3.default)(_analytics, REQUEST_SUGGESTION_TRIP, function (action) {
  return { name: 'Request Suggestion Trip', category: 'Suggestion Trip', bookingId: action.bookingId, tripIds: action.ids, providers: 'database' };
}), (0, _defineProperty3.default)(_analytics, CHANGE_TAB, function (action) {
  return { name: 'Change Tab', category: 'Trip Detail', tab: action.tab };
}), (0, _defineProperty3.default)(_analytics, COPY_LINK_SUCCESS, function () {
  return { name: 'Copy Link', category: 'Trip' };
}), (0, _defineProperty3.default)(_analytics, LOG_COPY_FIRSTBOOKING_CODE, function () {
  return {
    name: 'Click copy FIRSTBOOKING code',
    category: 'FIRSTBOOKING promo',
    providers: 'database'
  };
}), (0, _defineProperty3.default)(_analytics, LOG_COPY_SECONDOFF_CODE, function () {
  return {
    name: 'Click copy SECONDOFF15 code',
    category: 'SECONDOFF15 promo',
    providers: 'database'
  };
}), _analytics);
/*
export function isLoaded(globalState) {
  return globalState.trip && globalState.trip.loaded;
}*/
// export function isLoaded() {
//   return false;
// }

function load(slug) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/trips/slug/' + slug);
    }
  };
}
function loadAvailability(tripId, month) {
  return {
    types: [LOAD_AVAILABILITY, LOAD_AVAILABILITY_SUCCESS, LOAD_AVAILABILITY_FAIL],
    promise: function promise(client) {
      return client.get('/availability/calendar?trip_id=' + tripId + '&month=' + month);
    }
  };
}
function loadPeerReview(slug) {
  return {
    types: [LOAD_PEER_REVIEW, LOAD_PEER_REVIEW_SUCCESS, LOAD_PEER_REVIEW_FAIL],
    promise: function promise(client) {
      return client.get('/trips/slug/' + slug + '/peer-review');
    }
  };
}
function loadPeerTrips() {
  return {
    types: [LOAD_PEER_TRIPS, LOAD_PEER_TRIPS_SUCCESS, LOAD_PEER_TRIPS_FAIL],
    promise: function promise(client) {
      return client.get('/trips/peer-trips');
    }
  };
}
function updatePeerTrips() {
  var peerTrips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return {
    type: UPDATE_PEER_TRIPS,
    peerTrips: peerTrips
  };
}
function openChat() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_CHAT,
    active: active
  };
}
function openBook() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_BOOK,
    active: active
  };
}
function openExternal(url) {
  return {
    type: OPEN_EXTERNAL,
    url: url
  };
}
function openShare() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_SHARE,
    active: active
  };
}
function openPeerReview() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_PEER_REVIEW,
    open: open
  };
}
function submitPeerReview(slug, score, can) {
  return {
    types: [SUBMIT_PEER_REVIEW, SUBMIT_PEER_REVIEW_SUCCESS, SUBMIT_PEER_REVIEW_FAIL],
    promise: function promise(client) {
      return client.post('/trips/slug/' + slug + '/peer-review', { data: { score: score, can_do_this_trip: can } });
    }
  };
}
function clearData() {
  return {
    type: CLEAR_DATA
  };
}

function clickTrip(id, searchSessionId, rankingAlgorithm, index) {
  return {
    type: CLICK_TRIP,
    id: id,
    searchSessionId: searchSessionId,
    rankingAlgorithm: rankingAlgorithm,
    index: index
  };
}

function impressTrip(id, searchSessionId, rankingAlgorithm, index) {
  return {
    type: IMPRESS_TRIP,
    id: id,
    searchSessionId: searchSessionId,
    rankingAlgorithm: rankingAlgorithm,
    index: index
  };
}

function clickSimilarTrip(id, typeSim, index) {
  return {
    type: CLICK_SIMILAR_TRIP,
    id: id,
    typeSim: typeSim,
    index: index
  };
}

function impressSimilarTrip(id, typeSim, index) {
  return {
    type: IMPRESS_SIMILAR_TRIP,
    id: id,
    typeSim: typeSim,
    index: index
  };
}

function impressSuggestionTrip(bookingId) {
  return {
    type: IMPRESS_SUGGESTION_TRIP,
    bookingId: bookingId
  };
}

function clickSuggestionTrip(bookingId, id) {
  return {
    type: CLICK_SUGGESTION_TRIP,
    bookingId: bookingId,
    id: id
  };
}

function logClickBookNow(id, searchSessionId, rankingAlgorithm, index) {
  return {
    type: LOG_CLICK_BOOK_NOW,
    id: id,
    searchSessionId: searchSessionId,
    rankingAlgorithm: rankingAlgorithm,
    index: index
  };
}

function requestSuggestionTrip(bookingId, ids) {
  return {
    type: REQUEST_SUGGESTION_TRIP,
    bookingId: bookingId,
    ids: ids
  };
}

function changeTab(tab) {
  return {
    type: CHANGE_TAB,
    tab: tab
  };
}

function copyLink() {
  return {
    type: COPY_LINK_SUCCESS
  };
}

function logCopyFirstBookingCode() {
  return {
    type: LOG_COPY_FIRSTBOOKING_CODE
  };
}

function logCopySecondOffCode() {
  return {
    type: LOG_COPY_SECONDOFF_CODE
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/trip.js
// module id = 47
// module chunks = 47